import { MatxLoadable } from "matx";

const CafeteriaHome = MatxLoadable({
  loader: () => import("./CafeteriaHome"),
});

const CafeteriaRoutes = [
    {
      path: "/cafeteria/home",
      component: CafeteriaHome,
    }
  ];
  
  export default CafeteriaRoutes;